import {SELECTED_PASSENGER_DETAILS,ORIGIN_DROPDOWN,DESTINATION_DROPDOWN,FEESERVICE_DROPDOWN,PaymentType_Dropdown} from './SelectedPassengerType'


const initialState={
    SelectedPassengerData:{},
    DestinationDropdown:[],
    OriginDropdown:[],
    FeeServiceDropdown:[],
    PaymentTypeDropdown:[]
}

const selectedpassengerReducer=(state=initialState,action)=>
{   
    switch(action.type)
    {
        case SELECTED_PASSENGER_DETAILS: return{
            ...state,
            SelectedPassengerData:action.SelectedPassengerData
        }
        case ORIGIN_DROPDOWN: return{
            ...state,
            OriginDropdown:action.OriginDropdown
        }
        case DESTINATION_DROPDOWN : return{
            ...state,
            DestinationDropdown:action.DestinationDropdown
        }
        case FEESERVICE_DROPDOWN : return{
            ...state,
            FeeServiceDropdown:action.FeeServiceDropdown
        }
        case PaymentType_Dropdown : return{
            ...state,
            PaymentTypeDropdown:action.PaymentTypeDropdown
        }
        default: return state
    }
}

export default selectedpassengerReducer;